import { controls } from "../controls";

const ms1111 = {
  label: "GL Mapper",
  pageLabel: "GL Mapper",
  starting: true,
  url: "ms1111",
  bulk: { columns: ["gl_code", "cgroup", "bsgroup", "plgroup"] },
  formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "Modal", label: "General Ledger", width: "col-sm-2" }),
    ...controls.GL({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "gl_code_display", name: "gl_code_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Custom Group", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "cgroup" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "BS Group", width: "col-sm-2" }),
    ...controls.BSGroup({ tab: "filter" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "P&L Group", width: "col-sm-2" }),
    ...controls.PLGroup({ tab: "filter" }),
  ],


  form: [
    ...controls.displayText({ tab: "Modal", label: "General Ledger", width: "col-sm-2" }),
    ...controls.GL({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "gl_code_display", name: "gl_code_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Custom Group", width: "col-sm-2" }),
    ...controls.text({ tab: "filter", name: "cgroup" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "BS Group", width: "col-sm-2" }),
    ...controls.BSGroup({ tab: "filter" }),
    ...controls.displayText({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "P&L Group", width: "col-sm-2" }),
    ...controls.PLGroup({ tab: "filter" }),

  ],
  history: {
    perPage: 10,
    reportHeader: "GL Mappings",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "GL",
        accessor: "gl_code",
      },
      {
        Header: "GL",
        accessor: "cgroup",
      },
      {
        Header: "Balance Sheet Group",
        accessor: "bsgroup",
      },
      {
        Header: "P&L Group",
        accessor: "plgroup",
      }
    ]
  }
};

export default ms1111;